import React, { useEffect } from 'react';
import { Flex, Image, keyframes } from '@chakra-ui/react';
import { graphql, navigate } from 'gatsby';
import Loader from '@assets/images/melon-loader.png';

// Keyframe Animation.
const FruitLoader = keyframes`
  0% {transform: rotate(0deg);}
  100% {transform: rotate(360deg);}
`;

const LoadingPage = ({ data }) => {
  const locales = data.allLocale.nodes.map((locale) => {
    return locale.code;
  });

  // Get users browser language.
  // const userLocale = navigator.language || navigator.userLanguage;
  const userLocale =
    typeof navigator !== `undefined`
      ? navigator.language || navigator.userLanguage
      : ``;

  // Check if users locale matches one we have set in Strapi.
  const matchingLocale = locales.find((locale) => locale === userLocale);

  // Check if users locale part-matches one we have set in Strapi.
  const partMatchingLocale = locales.find(
    (locale) => userLocale.startsWith(locale)
    // eslint-disable-next-line function-paren-newline
  );

  // Set target locale with a three-stage fallback, where en is the default locale.
  // TODO: en value as a global setting?
  const targetLocale = matchingLocale || partMatchingLocale || `en`;

  useEffect(() => {
    // Navigate user to correct locale after 1.5s.
    const navigateTimeout = setTimeout(() => {
      navigate(`/${targetLocale}`);
    }, `1500`);
    return () => clearTimeout(navigateTimeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    // Spinning fruit loader.
    <Flex
      position="relative"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      width="100vw">
      <Image
        src={Loader}
        maxWidth="5rem"
        sx={{
          animation: `${FruitLoader} 1.5s linear infinite`
        }}
      />
    </Flex>
  );
};

export const Head = () => {
  return (
    <>
      {/* <html lang={targetLocale} /> */}
      <noscript>
        <meta httpEquiv="refresh" content="5; url=/en" />
      </noscript>
    </>
  );
};

export const query = graphql`
  query {
    allLocale {
      nodes {
        code
      }
    }
  }
`;

export default LoadingPage;
